import React, { useState, useEffect } from "react";
import "./imageGalleryModal.css";

function ImageGalleryModal({ images, initialIndex, isOpen, onClose }) {
  const [currentIndex, setCurrentIndex] = useState(initialIndex || 0);

  useEffect(() => {
    setCurrentIndex(initialIndex || 0);
  }, [initialIndex, isOpen]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!isOpen) return;
      
      if (e.key === "ArrowLeft") {
        handlePrevious();
      } else if (e.key === "ArrowRight") {
        handleNext();
      } else if (e.key === "Escape") {
        onClose();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isOpen, currentIndex, images]);

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % images.length);
  };

  const handlePrevious = () => {
    setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  if (!isOpen || !images || images.length === 0) return null;

  const currentImage = images[currentIndex];

  return (
    <div className="image-gallery-overlay" onClick={onClose}>
      <div className="image-gallery-modal" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="image-gallery-header">
          <div className="image-info">
            <span className="image-name">{currentImage?.name || `Image ${currentIndex + 1}`}</span>
            <span className="image-counter">
              {currentIndex + 1} / {images.length}
            </span>
          </div>
          <button className="close-button" onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>

        {/* Image Container */}
        <div className="image-gallery-body">
          <div className="image-container">
            {images.length > 1 && (
              <button
                className="nav-button nav-previous"
                onClick={handlePrevious}
                aria-label="Previous image"
              >
                ‹
              </button>
            )}

            <img
              src={currentImage?.preview || currentImage?.url}
              alt={currentImage?.name || `Image ${currentIndex + 1}`}
              className="gallery-image"
            />

            {images.length > 1 && (
              <button
                className="nav-button nav-next"
                onClick={handleNext}
                aria-label="Next image"
              >
                ›
              </button>
            )}
          </div>

          {/* Thumbnail Strip */}
          {images.length > 1 && (
            <div className="thumbnail-strip">
              {images.map((image, index) => (
                <div
                  key={index}
                  className={`thumbnail-item ${index === currentIndex ? "active" : ""}`}
                  onClick={() => setCurrentIndex(index)}
                >
                  <img
                    src={image?.preview || image?.url}
                    alt={image?.name || `Thumbnail ${index + 1}`}
                  />
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ImageGalleryModal;
